import "flatpickr/dist/themes/material_blue.css";
import "../../../assets/scss/datatables.scss";

import * as loadingAction from "../../../store/loading/action";
import * as messageAction from "../../../store/message/action";

import { AvField, AvForm } from "availity-reactstrap-validation";
import {
  Badge,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Modal,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  UncontrolledTooltip,
} from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { post, postUpload } from "../../../helpers/api_helper";

import BootstrapTable from "react-bootstrap-table-next";
// import CreatableSelect from "react-select/creatable";
import Flatpickr from "react-flatpickr";
import { GET_PUBLIC_REPORT } from "../../../helpers/url_api_constant";
import Loading from "../../../components/Custom/Loading";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import PropTypes from "prop-types";
import SectionAlarm from "../Daily_Dashboard/SectionAlarm/index";
import SectionBalancing from "../Daily_Dashboard/SectionBalancing/index";
import SectionCapacityOveruse from "../Daily_Dashboard/SectionCapacityOveruse/index";
import SectionCapacityOveruseByContact from "../Daily_Dashboard/SectionCapacityOveruseByContact/index";
import SectionDemandCustomerType from "../Daily_Dashboard/SectionDemandCustomerType/index";
import SectionDemandSupply from "../Daily_Dashboard/SectionDemandSupply/index";
import SectionQtyAndComFuel from "../Daily_Dashboard/SectionQtyAndComFuel/index";
import SectionShipper from "../Daily_Dashboard/SectionShipper/index";
import SectionTodayPlan from "../Daily_Dashboard/SectionTodayPlan/index";
import Tooltip from "react-bootstrap/Tooltip";
import classnames from "classnames";
import moment from "moment";
import paginationFactory from "react-bootstrap-table2-paginator";
import { withTranslation } from "react-i18next";

//i18n
// window.onresize = function (event) {
//       for (let id in Chart.instances) {
//         Chart.instances[id].resize();
//       }
// }




function Daily_Dashboard(props) {
  let history = useHistory();

  const dispatch = useDispatch();

  const [summaryReportPid, setSummaryReportPid] = useState("");

  const searchObj = {
    SELECT_DATE: new Date(),
  };

  const [searchModel, setSearchModel] = useState(searchObj);
  const [activeTab, setActiveTab] = useState("1");
  let body = document.querySelector("body");
function callback(mutationList, observer) {
  mutationList.forEach(function (mutation) {
    if (mutation.type === "attributes" && mutation.attributeName === "class") {
      if (body.classList.contains("vertical-collpsed")) {
        body.style.overflowY = "hidden";
      } else {
        body.style.overflowY = "auto";
      }
    }
  });
}
const observer = new MutationObserver(callback);
  useEffect(() => {
    observer.observe(body, { attributes: true });
    return () => {
      observer.disconnect();
      body.style.overflowY = "auto";
    };
  }, []);
  useEffect(
    function () {
      getPIDPublicSummary();
    },
    [searchModel.SELECT_DATE]
  );

  // useEffect(
  //   function () {
  //     console.log(summaryReportPid);
  //   },
  //   [searchModel.SELECT_DATE]
  // );

  const getPIDPublicSummary = async () => {
    dispatch(loadingAction.showLoading());
    try {
      let res = await post(GET_PUBLIC_REPORT, {
        SUMMARYREPORT_DATE: moment(searchModel.SELECT_DATE)
          .add(-1, "day")
          .format("YYYY-MM-DD"),
      });
      if (res.resultCode == 200) {
        setSummaryReportPid(res.data.PID);
        // console.log(res.data.PID);
      } else {
        setSummaryReportPid(null);
        dispatch(messageAction.showMessage(res.resultDescription));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  return (
    <React.Fragment>
      <div
        className="page-content mb-0 pb-0"
        style={{ position: "relative", height: "100vh" }}
      >
        <Container fluid>
          {/* <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                    <h1 className="mb-sm-0 font-size-20">
                      {" "}
                      {props.t("Daily Dashboard")}
                    </h1>
                    <div className="page-title-right">
                      <ol className="breadcrumb m-0">
                        <li className="breadcrumb-item">
                          <Link to="#" style={{ color: "#556ee6" }}>
                            Dashboards
                          </Link>
                        </li>
                        <li className="breadcrumb-item active">Daily Dashboard</li>
                      </ol>
                    </div>
                  </div>
                </CardBody>
              </Card>

              <Row className="align-items-center justify-content-end">
                <Col sm="12">
                  <Card style={{ backgroundColor: "#5b68a759", borderRadius: "3vw" ,height: "3.2vw",position:'relative' }}>
                    <CardBody>
                      <FormGroup className="row">
                        <Col sm={6}></Col>
                        <Col sm={2} className="d-flex align-items-center justify-content-end mt-2">

                          <i className="dripicons-alarm" style={{ fontSize: "2em" }} />

                        </Col>
                        <Col sm={4} className="col-form-label d-flex align-items-left justify-content-start">
                          <Flatpickr
                            className="form-control d-block"
                            placeholder="Select Date"
                            options={{
                              altInput: true,
                              altFormat: "d/m/Y",
                              // altFormat: "F Y",
                              dateFormat: "d/m/Y",
                              maxDate: new Date(),
                            }}
                            onChange={value => {
                              setSearchModel({
                                ...searchModel,
                                SELECT_DATE: value[0],

                              });
                            }}
                            value={searchModel.SELECT_DATE}

                          />

                          <div className="input-group-append">
                            <button
                              type="button"
                              className="btn btn-outline-secondary docs-datepicker-trigger"
                              disabled
                            >
                              <i
                                className="fa fa-calendar"
                                aria-hidden="true"
                              />
                            </button>
                          </div>
                        </Col>
                      </FormGroup>
                    </CardBody>
                  </Card>
                </Col>
              </Row>

            </Col>
          </Row> */}

          <Row className="dashboard-content">
            <Col sm="12">
              <TabContent activeTab={activeTab}>
                <TabPane tabId="1" className="content-dashboard-auto-scroll">
                  <SectionDemandSupply
                    date={moment(searchModel.SELECT_DATE).add(-1, "day")}
                    summaryReportPid={summaryReportPid}
                  />
                </TabPane>
                <TabPane tabId="2" className="content-dashboard-auto-scroll">
                  <SectionDemandCustomerType
                    date={moment(searchModel.SELECT_DATE).add(-1, "day")}
                    summaryReportPid={summaryReportPid}
                  />
                </TabPane>
                <TabPane tabId="3" className="content-dashboard-auto-scroll">
                  <SectionBalancing
                    date={moment(searchModel.SELECT_DATE).add(-1, "day")}
                    summaryReportPid={summaryReportPid}
                  />
                </TabPane>
                <TabPane tabId="4" className="content-dashboard-auto-scroll">
                  <SectionCapacityOveruse
                    date={moment(searchModel.SELECT_DATE).add(-1, "day")}
                    summaryReportPid={summaryReportPid}
                  />
                </TabPane>
                {/* <TabPane tabId="5" className="content-dashboard-auto-scroll">
                  <SectionCapacityOveruseByContact
                    date={moment(searchModel.SELECT_DATE).add(-1, "day")}
                    summaryReportPid={summaryReportPid}
                  />
                </TabPane> */}
                <TabPane tabId="6" className="content-dashboard-auto-scroll">
                  <SectionQtyAndComFuel
                    date={moment(searchModel.SELECT_DATE).add(-1, "day")}
                    summaryReportPid={summaryReportPid}
                  />
                </TabPane>
                {/* <TabPane tabId="7">
                  <SectionShipper date={searchModel.DATE} summaryReportPid={summaryReportPid} />
                </TabPane> */}
                <TabPane tabId="7" className="content-dashboard-auto-scroll">
                  <SectionAlarm
                    date={moment(searchModel.SELECT_DATE).add(-1, "day")}
                    summaryReportPid={summaryReportPid}
                  />
                </TabPane>
                <TabPane tabId="8" className="content-dashboard-auto-scroll">
                  <SectionTodayPlan
                    date={moment(searchModel.SELECT_DATE).add(-1, "day")}
                    summaryReportPid={summaryReportPid}
                  />
                </TabPane>
                {/* <TabPane tabId="9">
                  <h1>hello</h1>
                </TabPane>
                <TabPane tabId="10">
                  <h1>hello</h1>
                </TabPane> */}
              </TabContent>
            </Col>
          </Row>

          <Row className="mt-0 tabmenu-daily-dashboard">
            <div className="checkout-tabs mb-0">
              <Row>
                <Col
                  sm="3"
                  className="d-flex align-items-center justify-content-center"
                >
                  <Col
                    sm="12"
                    className="col-form-label d-flex align-items-center justify-content-center"
                  >
                    {/* <i className="dripicons-alarm"  /> */}
                    <Flatpickr
                      className="form-control d-block ms-1"
                      placeholder="Select Date"
                      options={{
                        altInput: true,
                        altFormat: "d/m/Y",
                        // altFormat: "F Y",
                        dateFormat: "d/m/Y",
                        maxDate: new Date(),
                      }}
                      onChange={value => {
                        // setTempSearch({
                        //   ...tempSearch,
                        //   SELECT_DATE: value[0],
                        // });
                        setSearchModel({
                          ...searchModel,
                          SELECT_DATE: value[0],

                          // SELECT_DATE: moment(value[0].setDate(value[0].getDate() - 1)).format("YYYY-MM-DD")
                        });
                      }}
                      value={searchModel.SELECT_DATE}
                    />

                    <div className="input-group-append">
                      <button
                        type="button"
                        className="btn btn-outline-secondary docs-datepicker-trigger"
                        disabled
                      >
                        <i className="fa fa-calendar" aria-hidden="true" />
                      </button>
                    </div>
                  </Col>
                </Col>

                <Col
                  sm="9"
                  style={{ backgroundColor: "#ffffff14", borderRadius: "45px" }}
                >
                  <Nav
                    className="flex-row justify-content-between nav-menu-dashboard"
                    pills
                  >
                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: activeTab === "1",
                        })}
                        onClick={() => {
                          setActiveTab("1");
                        }}
                      >
                        <OverlayTrigger
                          placement="left-start"
                          overlay={
                            <Tooltip id="tooltip-disabled">
                              <strong style={{ fontSize: 14 }}>
                                System Entry & Exit Summary
                              </strong>
                            </Tooltip>
                          }
                        >
                          <i className="mdi mdi-factory " />
                          {/* <p className="font-weight-bold mb-4"> </p> */}
                        </OverlayTrigger>
                      </NavLink>
                    </NavItem>

                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: activeTab === "2",
                        })}
                        onClick={() => {
                          setActiveTab("2");
                        }}
                      >
                        <OverlayTrigger
                          placement="left-start"
                          overlay={
                            <Tooltip id="tooltip-disabled">
                              <strong style={{ fontSize: 14 }}>
                                Demand for Customer Types
                              </strong>
                            </Tooltip>
                          }
                        >
                          <i className="far fa-user-circle  " />
                        </OverlayTrigger>
                        {/* //id="DFCT" */}
                        {/* <UncontrolledTooltip
                            placement="bottom-start"
                            target="DFCT"
                            style={{ maxWidth: "300px" }}
                          >
                            <span style={{ fontSize: "15px" }}>
                              Demand for Customer Types
                            </span>
                          </UncontrolledTooltip>
                        </i> */}
                        {/* <p className="font-weight-bold mb-4"></p> */}
                      </NavLink>
                    </NavItem>

                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: activeTab === "3",
                        })}
                        onClick={() => {
                          setActiveTab("3");
                        }}
                      >
                        <OverlayTrigger
                          placement="left-start"
                          overlay={
                            <Tooltip id="tooltip-disabled">
                              <strong style={{ fontSize: 14 }}>
                                Balancing
                              </strong>
                            </Tooltip>
                          }
                        >
                          <i className="fas fa-balance-scale  " />
                        </OverlayTrigger>
                        {/* <p className="font-weight-bold mb-4"></p> */}
                      </NavLink>
                    </NavItem>

                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: activeTab === "4",
                        })}
                        onClick={() => {
                          setActiveTab("4");
                        }}
                      >
                        <OverlayTrigger
                          placement="left-start"
                          overlay={
                            <Tooltip id="tooltip-disabled">
                              <strong style={{ fontSize: 14 }}>
                                Shipper Summary
                              </strong>
                            </Tooltip>
                          }
                        >
                          <i className="bx bxs-ship  " />
                          {/* <p className="font-weight-bold mb-4"></p> */}
                        </OverlayTrigger>
                      </NavLink>
                    </NavItem>
                    {/* <NavItem>
                      <NavLink
                        className={classnames({
                          active: activeTab === "5",
                        })}
                        onClick={() => {
                          setActiveTab("5");
                        }}
                      >
                        <OverlayTrigger
                          placement="left-start"
                          overlay={
                            <Tooltip id="tooltip-disabled">
                              <strong style={{ fontSize: 14 }}>
                                Capacity Overuse by Contact
                              </strong>
                            </Tooltip>
                          }
                        >
                          <i className="fas fa-hand-point-up  " />
                          <p className="font-weight-bold mb-4"></p>
                        </OverlayTrigger>
                      </NavLink>
                    </NavItem> */}
                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: activeTab === "6",
                        })}
                        onClick={() => {
                          setActiveTab("6");
                        }}
                      >
                        <OverlayTrigger
                          placement="left-start"
                          overlay={
                            <Tooltip id="tooltip-disabled">
                              <strong style={{ fontSize: 14 }}>
                                Quality and Compressor Fuel
                              </strong>
                            </Tooltip>
                          }
                        >
                          <i className="bx bx-hdd bx-rotate-90"></i>
                          {/* <p className="font-weight-bold mb-4"></p> */}
                        </OverlayTrigger>
                      </NavLink>
                    </NavItem>
                    {/* 
                    <NavItem style={{ width: "92px" }}>
                      <NavLink
                        style={{ borderRadius: "50px" }}
                        className={classnames({
                          active: activeTab === "7",
                        })}
                        onClick={() => {
                          setActiveTab("6")
                        }}
                      >
                        <i className="fas fa-map  mt-3 mb-2" style={{ fontSize: "4em" }} />
                      
                      </NavLink>
                    </NavItem> */}

                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: activeTab === "7",
                        })}
                        onClick={() => {
                          setActiveTab("7");
                        }}
                      >
                        <OverlayTrigger
                          placement="left-start"
                          overlay={
                            <Tooltip id="tooltip-disabled">
                              <strong style={{ fontSize: 14 }}>
                                Alarm Management
                              </strong>
                            </Tooltip>
                          }
                        >
                          <i className="mdi mdi-alarm-light  " />
                          {/* <p className="font-weight-bold mb-4"></p> */}
                        </OverlayTrigger>
                      </NavLink>
                    </NavItem>

                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: activeTab === "8",
                        })}
                        onClick={() => {
                          setActiveTab("8");
                        }}
                      >
                        <OverlayTrigger
                          placement="left-start"
                          overlay={
                            <Tooltip id="tooltip-disabled">
                              <strong style={{ fontSize: 14 }}>
                                Today Plan
                              </strong>
                            </Tooltip>
                          }
                        >
                          <i className="bx bxs-calendar  " />
                          {/* <p className="font-weight-bold mb-4"></p> */}
                        </OverlayTrigger>
                      </NavLink>
                    </NavItem>
                    {/* 
                    <NavItem style={{ width: "95px" }}>
                      <NavLink
                        style={{ borderRadius: "50px" }}
                        className={classnames({
                          active: activeTab === "9",
                        })}
                        onClick={() => {
                          setActiveTab("9")
                        }}
                      >
                        <i className="mdi mdi-notebook  mt-3 mb-2" style={{ fontSize: "4em" }} />

                      </NavLink>
                    </NavItem>

                    <NavItem style={{ width: "92px" }}>
                      <NavLink
                        style={{ borderRadius: "50px" }}
                        className={classnames({
                          active: activeTab === "10",
                        })}
                        onClick={() => {
                          setActiveTab("10")
                        }}
                      >
                        <i className="fas fa-home d-block  mt-3 mb-2" style={{ fontSize: "4em" }} />

                      </NavLink>
                    </NavItem> */}
                  </Nav>
                </Col>
              </Row>
            </div>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}

Daily_Dashboard.propTypes = {
  t: PropTypes.any,
};

const mapStateToProps = ({ Daily_Dashboard }) => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Daily_Dashboard));
